import UtensilsIcon from '@ps-design-system/icons/Utensils/Utensils32';
import React from 'react';
import { CateringBookingDetailsBar } from '../catering-booking-details/CateringBookingDetailsBar';
import { CateringBookingDetailsTray } from '../catering-booking-details/CateringBookingDetailsTray';
import { CateringHeroImagesDesktop } from './CateringHeroImagesDesktop';
import { CateringHeroImagesMobile } from './CateringHeroImagesMobile';
import { CateringHeroMenuLink } from './CateringHeroMenuLink';

export const CateringHeroSection = ({ booking, listing }) => {
  return (
    <>
      <div className="ps-container-lg-margin ps-container-fixed relative">
        <CateringHeroImagesDesktop />

        <div className="ps-row">
          <div className="col-xs-12 catering-hero-inner">
            <div className="hero-text-container">
              <div className="text-brand-primary tw-headline-1-m catering-now-available-text">
                Now available in LA
              </div>
              <h1 className="no-margin tw-headline-6-b md:tw-display-1-b margin-lg-bottom catering-title-hidden-mobile">
                Catering for your event
                <br />— made easy
              </h1>
              <h1 className="no-margin tw-headline-6-b md:tw-display-1-b margin-lg-bottom catering-title-hidden-desktop">
                Catering for your
                <br />
                event — made easy
              </h1>
              <p className="no-margin tw-body-4 catering-hero-subtext">
                Take your event to the next level with a wide-ranging selection
                of tasty options, curated by top local chefs.
              </p>
            </div>
            <ul className="catering-hero-links-wrap">
              <CateringHeroMenuLink
                href="#gather-and-graze"
                title="Gather and graze"
              />
              <CateringHeroMenuLink href="#filling-fare" title="Filling fare" />
              <CateringHeroMenuLink
                href="#instagrammable-displays"
                title="Instagrammable displays"
              />
            </ul>

            <CateringHeroImagesMobile />

            <div className="catering-booking-details-mobile">
              <CateringBookingDetailsTray booking={booking} listing={listing} />
            </div>

            <div className="catering-info-block">
              <UtensilsIcon style={{ minWidth: '32px' }} />
              <p className="no-margin tw-body-1-long">
                <span className="tw-body-1-m">
                  Not positive on all the details yet?
                </span>{' '}
                Don't worry! Book now and modify your selections and event
                details up to three days before your event.
              </p>
            </div>
          </div>
        </div>
      </div>
      <CateringBookingDetailsBar booking={booking} listing={listing} />
    </>
  );
};
